<template>
  <div class="row u-s-m-x-0">
    <div class="col-lg-6 col-md-6 col-sm-12 u-s-p-x-0">
      <div class="newsletter-image">
        <a class="banner-hover effect-dark-opacity">
          <img
            class="img-fluid ban"
            :src="publicPath + 'assets/images/banners/newsletter-1.jpg'"
            alt="Newsletter Image"
          />
        </a>
      </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
      <div class="modal-body" v-if="outOfRange">
        <div class="vertical-center">
          <div class="text-center">
            <h1>S<i class="fas fa-sad-cry"></i>rry!</h1>
            <h5>
              Unfortunately, it looks like CalsoB isn't available in your
              area yet.
            </h5>
            <div class="redirect-link-wrapper u-s-p-t-25">
              <a
                class="redirect-link"
                href="#"
                @click="redirectLocationSelection"
              >
                <span>Return to Location Selection</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="map" id="map" v-if="!outOfRange">
        <GMapAutocomplete
          placeholder="Enter Your Address"
          class="form-control p-2"
          ref="gmapAutocomplete"
          @place_changed="setPlace($event)"
        >
        </GMapAutocomplete>
        <GMapMap
          :center="center"
          :zoom="zoom"
          style="width: 500px; height: 300px"
          ref="myMapRef"
          @click="handleClick($event)"
        >
          <GMapCluster>
            <GMapMarker
              :key="index"
              v-for="(m, index) in markers"
              :position="m.position"
              :clickable="true"
              :draggable="false"
              @click="center = m.position"
              @position_changed="updateCoordinates($event)"
            />
          </GMapCluster>
        </GMapMap>
        <button class="button button-primary d-block w-100 mt-4" @click="save">
          {{ saving ? "Please Wait." : "Select current location" }}
        </button>
      </div>
      <div class="newsletter-wrapper">
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div
    class="modal fade"
    id="loginModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header d-flex justify-content-between">
          <h5 class="modal-title" id="exampleModalLabel">Login</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-group">
              <label for="recipient-name" class="col-form-label">Email</label>
              <input type="email" class="form-control" id="email" />
            </div>
            <div class="form-group">
              <label for="message-text" class="col-form-label">Password</label>
              <input type="password" class="form-control" id="password" />
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="button button-primary d-block"
            data-dismiss="modal"
          >
            Close
          </button>
          <button type="button" class="button button-primary d-block">
            Login
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { publicPath } from "../../vue.config";
import { useToast } from "vue-toastification";
import { checkInRange } from "../utils/common_functions";
export default {
  data() {
    return {
      publicPath: publicPath,
      showLocationButton: false,
      center: { lat: 51.093048, lng: 6.84212 },
      address: "",
      search: false,
      loading: false,
      saving: false,
      zoom: 7,
      outOfRange: false,
      markers: [
        {
          position: {
            lat: 51.093048,
            lng: 6.84212,
          },
        }, // Along list of clusters
      ],
    };
  },

  methods: {
    //form lat and lng we are getting array of result
    getAddressFrom(lat, lng) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axios.get(
            "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
              lat +
              "," +
              lng +
              "&key=AIzaSyA9Az_2wI5BBoLGDkkC8xXxO3b0pVtsGuU"
          );
          return resolve(res.data.results);
        } catch (error) {
          return reject(error);
        }
      });
    },
    setPlace(event) {
      this.search = true;
      this.center = {
        lat: event.geometry.location.lat(),
        lng: event.geometry.location.lng(),
      };
      this.markers[0].position = event.geometry.location;
      this.zoom = 17;
      this.address = event.name + ", " + event.formatted_address;
    },
    updateCoordinates(location) {
      let cord = { lat: location.lat(), lng: location.lng() };
      this.center = cord;
    },
    //when somone click on map
    handleClick(event) {
      this.search = false;
      let cord = { lat: event.latLng.lat(), lng: event.latLng.lng() };
      console.log(cord);
      this.markers[0].position = cord;
      this.center = cord;
    },

    login() {
      // this.$router.push({name : "Auth"})
    },

    async save() {
      this.saving = true;
      if (!this.search) {
        let address = await this.getAddressFrom(
          this.center.lat,
          this.center.lng
        );
        this.address = address[0].formatted_address;
        // this.saveAddressToDB();
      }
      this.search = false;
      try {
        let res = await checkInRange(this.center.lat, this.center.lng);
        if (res == true) {
          localStorage.setItem("location", JSON.stringify(this.center));
          this.$router.go(this.$router.currentRoute);
          this.outOfRange = false;
        } else {
          this.outOfRange = true;
        }
        this.saving = false;
      } catch (error) {
        console.log(error);
        this.saving = false;
      }

      // console.log(this.address, this.center)
    },

    redirectLocationSelection() {
      this.outOfRange = false;
    },

    checkPermission() {
      navigator.geolocation.watchPosition(
        function (position) {
          console.log("Using Navigator API");
        },
        function (error) {
          if (error.code == error.PERMISSION_DENIED)
            useToast().error("Location Permission Denied", { timeout: 3000 });
        }
      );
    },

    setCurrentLocation() {
      this.checkPermission();
      navigator.geolocation.getCurrentPosition(
        ({ coords: { latitude, longitude } }) => {
          console.log(latitude, longitude);
          //intial Load
          if (latitude && longitude) {
            this.loading = true;
          }
          this.getAddressFrom(latitude, longitude).then((res) => {
            if (this.$refs.gmapAutocomplete) {
              this.$refs.gmapAutocomplete.$refs.input.value =
                res[0].formatted_address;
            }
            this.loading = false;
          });
          let latlng = { lat: latitude, lng: longitude };
          this.center = latlng;
          this.markers[0].position = latlng;
          this.showLocationButton = true;
          this.zoom = 17;
          this.search = false;
        }
      );
    },
  },

  mounted() {
    this.setCurrentLocation();
    console.log("Landing Page Mounted");
  },
};
</script>

<style scoped>
.map {
  height: 400px;
}
.ban {
  margin: 0px;
  transform: scale(1);
}
.modal-body {
  height: 100%;
}
.modal-dialog {
  width: 50%;
}
</style>
